var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTicketReserve(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconamoon:attention-circle-fill",
    clipPath: "url(#clip0_7783_70805)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 7C0 3.1339 3.1339 0 7 0C10.8661 0 14 3.1339 14 7C14 10.8661 10.8661 14 7 14C3.1339 14 0 10.8661 0 7ZM7 7.7C6.81435 7.7 6.6363 7.62625 6.50503 7.49497C6.37375 7.3637 6.3 7.18565 6.3 7V4.2C6.3 4.01435 6.37375 3.8363 6.50503 3.70503C6.6363 3.57375 6.81435 3.5 7 3.5C7.18565 3.5 7.3637 3.57375 7.49497 3.70503C7.62625 3.8363 7.7 4.01435 7.7 4.2V7C7.7 7.18565 7.62625 7.3637 7.49497 7.49497C7.3637 7.62625 7.18565 7.7 7 7.7ZM5.95 9.8C5.95 9.52152 6.06062 9.25445 6.25754 9.05754C6.45445 8.86062 6.72152 8.75 7 8.75H7.007C7.28548 8.75 7.55255 8.86062 7.74946 9.05754C7.94638 9.25445 8.057 9.52152 8.057 9.8V9.807C8.057 10.0855 7.94638 10.3525 7.74946 10.5495C7.55255 10.7464 7.28548 10.857 7.007 10.857H7C6.72152 10.857 6.45445 10.7464 6.25754 10.5495C6.06062 10.3525 5.95 10.0855 5.95 9.807V9.8Z",
    fill: "#009EF8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7783_70805"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketReserve);
export default __webpack_public_path__ + "static/media/ticket-reserve.9b5ca6e05dadad950eff5bcb4b72f3d0.svg";
export { ForwardRef as ReactComponent };